<template>
	<div ref="container" />
</template>

<script setup lang="ts">

	import {
		ref,
		onMounted,
		onUnmounted,
	} from "vue"

	const container = ref<HTMLElement | null>(null)

	let widgetId = ""
	let resolveToken: ((token: string) => void) | null = null
	let rejectToken: ((err: Error) => void) | null = null

	onMounted(() => {
		if (process.env.VUE_APP_ENABLE_CF_TURNSTILE !== "1" || !container.value) return

		widgetId = turnstile.render(container.value, {
			sitekey: process.env.VUE_APP_CF_TURNSTILE_SITE_KEY,
			appearance: "interaction-only",
			execution: "execute",
			size: "flexible",
			callback: (token: string) => {
				resolveToken?.(token)
				resolveToken = null
				rejectToken = null
			},
			"expired-callback": () => {
				rejectToken?.(new Error("Security check expired. Please try again."))
				resolveToken = null
				rejectToken = null
			},
			"error-callback": () => {
				rejectToken?.(new Error("Security check failed. Disable any VPNs or ad-blockers and try again."))
				resolveToken = null
				rejectToken = null
			},
		})
	})

	onUnmounted(() => {
		if (widgetId) turnstile.remove(widgetId)
	})

	async function execute(): Promise<string> {
		if (process.env.VUE_APP_ENABLE_CF_TURNSTILE !== "1") return ""

		const token = await new Promise<string>((resolve, reject) => {
			resolveToken = resolve
			rejectToken = reject
			turnstile.execute(widgetId)
		})

		turnstile.reset(widgetId)

		return token
	}

	defineExpose({ execute })
</script>